import React, {useEffect} from 'react';
import {useDispatch, useSelector} from "react-redux";
import {useNavigate, useSearchParams} from "react-router-dom";

import {clearHistoricoParcial, setHistoricoParcial} from "../actions";

import useFetch from "../hooks/useFetch";
import useErrorMessage from "../hooks/useErrorMessage";

import PageWrapper from "./shared/pagewrapper/PageWrapper";
import DataGrid from "./shared/datagrid/DataGrid";
import Message from "./shared/message/Message";

import {URL_HISTORICO_ALUNO} from "../constants";

import clsx from "clsx";

import {containedButton, textButton} from "../utils/styles";

import Grid from "@material-ui/core/Grid";
import {Paper} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {DescriptionOutlined, SearchOutlined} from "@material-ui/icons";
import {makeStyles} from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
    ...containedButton(theme, true, false),
    ...textButton(theme, false),
    titleTypograph: {
        textAlign: 'center',
        marginBottom: theme.spacing(4)
    },
    datagridContainer: {
        margin: '0 auto',
        [theme.breakpoints.up('sm')]: {
            maxWidth: 800
        }
    },
    buttonsContainer: {
        display: 'flex',
        justifyContent: 'center'
    },
    buttonsWidth: {
        display: 'flex',
        width: 500,
        gap: theme.spacing(2),
        [theme.breakpoints.down('xs')]: {
            flexWrap: 'wrap',
            width: '100%',
            maxWidth: 400
        }
    },
    downloadTypograph: {
        textAlign: 'center'
    }
}));
export default function PageHistoricoParcial () {
    const classes = useStyles();

    const dispatch = useDispatch();
    const fetch = useFetch();

    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();

    const credencial = searchParams.get("credencial");

    const historicoParcial = useSelector(state => state.historicoParcial);

    const showErrorMessage = useErrorMessage();

    const onClickPesquisarNovamente = () => {
        dispatch(clearHistoricoParcial());

        navigate('/');
    }

    const onClickDownloadButton = (url) => {
        window.location.href = url;
    }

    const historicoParcialNaoEncontrado = () => {
        return (
            <PageWrapper>
                <Message type='info'>
                    Histórico Parcial não disponível!
                </Message>
            </PageWrapper>
        );
    }

    const historicoParcialContent = () => {
        return (
            <PageWrapper>
                <Grid container spacing={3}>
                    <Grid item xs={12}>
                        <Typography
                            variant="h4"
                            component="h1"
                            color='primary'
                            gutterBottom
                            className={classes.titleTypograph}>
                            Validar Histórico Parcial de Graduação
                        </Typography>
                        <DataGrid
                            rows={historicoParcial ? [historicoParcial] : []}
                            tableContainerProps={{
                                component: Paper,
                                className: classes.datagridContainer
                            }}
                            responsive
                            comparatorKeys={['hash']}
                            columns={[
                                {
                                    label: 'Código de Validação',
                                    field: 'hash'
                                },
                                {
                                    label: 'Nome',
                                    field: 'nome'
                                }
                            ]} />
                    </Grid>
                    <Grid item xs={12}>
                        <Typography
                            className={classes.downloadTypograph}>
                            <strong>Download dos documentos:</strong>
                        </Typography>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid container spacing={2}>
                            {!!historicoParcial.urlHistoricoPDF && (
                                <Grid item xs={12}>
                                    <div className={classes.buttonsContainer}>
                                        <div className={classes.buttonsWidth}>
                                            <Button
                                                variant="contained"
                                                startIcon={<DescriptionOutlined />}
                                                className={clsx(classes.containedButton)}
                                                disabled={!historicoParcial}
                                                fullWidth
                                                onClick={() => {onClickDownloadButton(historicoParcial.urlHistoricoPDF)}}>
                                                Histórico em PDF
                                            </Button>
                                            <Button
                                                variant="contained"
                                                startIcon={<DescriptionOutlined />}
                                                className={clsx(classes.containedButton)}
                                                disabled={!historicoParcial}
                                                fullWidth
                                                onClick={() => {onClickDownloadButton(historicoParcial.urlHistoricoXML)}}>
                                                Histórico em XML
                                            </Button>
                                        </div>
                                    </div>
                                </Grid>
                            )}
                        </Grid>
                    </Grid>
                    {!credencial && (
                        <Grid item xs={12}>
                            <div className={classes.buttonsContainer}>
                                <Button
                                    startIcon={<SearchOutlined />}
                                    className={classes.textButton}
                                    fullWidth
                                    onClick={onClickPesquisarNovamente}>
                                    Pesquisar novamente
                                </Button>
                            </div>
                        </Grid>
                    )}
                </Grid>
            </PageWrapper>
        );
    }

    useEffect(() => {
        if (!historicoParcial) {
            if (credencial) {
                fetch(URL_HISTORICO_ALUNO, {
                    credencial: credencial
                }, fetchedHistorico => {
                    dispatch(setHistoricoParcial(fetchedHistorico));
                }, (error, asyncErrorHandler) => {
                    if (error.detalhe) {
                        console.log(error.detalhe);
                    } else {
                        console.log(error.mensagem || error);
                    }
                })
            }
        }
    }, [historicoParcial]);

    return !!historicoParcial ? historicoParcialContent() : historicoParcialNaoEncontrado();
}